<template>
  <div>
    <template v-if="disabled"> {{ data }} {{ value }} </template>
    <!-- class="demo-inline-spacing" class="form-control"

      :placeholder="$t('_components.placeholder.select')+label"-->
    <a-range-picker
      v-else
      v-model="value"
      size="large"
      :disabled="disabled"
      format="DD MMM YYYY"
      valueFormat="YYYY-MM-DD"
      :disabled-date="disabledDate"
      @change="dateChange"
    />
  </div>
</template>

<script>
import moment from 'moment'

export default {
  components: {},
  props: {
    value: {
      type: [String, Number, Object, Array, Boolean],
      default: null,
    },
    option: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      data: [],
      // defaultValue:
      disabledStartDate: moment(this.option.disabledStartDate),
      disabledEndDate: moment(this.option.disabledEndDate),
    }
  },
  watch: {
    data: {
      deep: true,
      handler(e) {
        console.log(e, '========range   eeee')
        this.$emit('input', e)
      },
    },
    value: {
      handler(e) {
        console.log('sadad', e)
        // 用于清空选择器
        if (!e) {
          this.data = []
        } else {
          this.data = e
        }
      },
      deep: true,
    },
  },
  methods: {
    moment,
    dateChange(dates, dateStrings) {
      console.log(dates, dateStrings, 'dateStrings')
      this.data = dates
    },
    disabledDate(current) {
      const newDate = moment(current).format('YYYY-MM-DD')
      if (!this.option.disabledStartDate || !this.option.disabledEndDate) {
        return ''
      }
      return (
        moment(newDate).isBefore(
          moment(this.disabledStartDate).format('YYYY-MM-DD')
        ) ||
        moment(newDate).isAfter(
          moment(this.disabledEndDate).format('YYYY-MM-DD')
        )
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.form-control {
  height: 100%;
  width: 100%;
  margin: 0;
}
.ant-calendar-picker {
  width: 100%;
}
</style>
